var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8599 15.1666H4.13992C2.31325 15.1666 0.833252 13.68 0.833252 11.8533V6.9133C0.833252 6.00663 1.39325 4.86663 2.11325 4.30663L5.70659 1.50663C6.78659 0.666629 8.51325 0.626629 9.63325 1.4133L13.7533 4.29996C14.5466 4.8533 15.1666 6.03996 15.1666 7.00663V11.86C15.1666 13.68 13.6866 15.1666 11.8599 15.1666ZM6.31992 2.2933L2.72659 5.0933C2.25325 5.46663 1.83325 6.3133 1.83325 6.9133V11.8533C1.83325 13.1266 2.86659 14.1666 4.13992 14.1666H11.8599C13.1333 14.1666 14.1666 13.1333 14.1666 11.86V7.00663C14.1666 6.36663 13.7066 5.47996 13.1799 5.11996L9.05992 2.2333C8.29992 1.69996 7.04658 1.72663 6.31992 2.2933Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.5C7.72667 12.5 7.5 12.2733 7.5 12V10C7.5 9.72667 7.72667 9.5 8 9.5C8.27333 9.5 8.5 9.72667 8.5 10V12C8.5 12.2733 8.27333 12.5 8 12.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeImage);
export default __webpack_public_path__ + "static/media/home-image.82c7d00a43939aa9b621dbd79283a73b.svg";
export { ForwardRef as ReactComponent };